// The agents area's shell (spec 14 §4, D-512, D-529 ruling 1): the Hub and the
// journal as two tabs, the agent detail under the Hub. The Hub's tab is offered
// to a reader who may list agents (`agents.read`, or `agents.invoke` read-only
// for its own domain); the journal's to every office role, since the journal
// has no code (§7.1) and the server serves each reader its own cards.
//
// RENDER-ONCE (design-system §5): the strip depends on the role feed, so the
// area is a reserving skeleton until it settles, then remounts whole.

import { Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { CardSkeleton } from "../../../components/states";
import { RouterTabs, type RouterTabDef } from "../../../components/tabs";
import { useAgentsPermissions } from "./hooks/permissions";
import "./agents.css";

export function AgentsLayout() {
  const { t } = useTranslation();
  const perms = useAgentsPermissions();

  if (!perms.isResolved) {
    return (
      <div className="ag-area" key="agents-loading" data-testid="agents-loading">
        <div className="ds-tabs ag-subnav-skel" aria-hidden="true" />
        <div className="ag-body">
          <CardSkeleton lines={6} label={t("agents.common.loading")} />
        </div>
      </div>
    );
  }

  const tabs: RouterTabDef[] = [];
  if (perms.canList) {
    tabs.push({
      to: "/agents",
      label: t("agents.nav.hub"),
      "data-testid": "agents-nav-hub",
      // The journal sits below `/agents`, so the Hub lights on its own path
      // only; an agent's detail page names the Hub in its breadcrumb.
      exact: true,
    });
  }
  tabs.push({
    to: "/agents/journal",
    label: t("agents.nav.journal"),
    "data-testid": "agents-nav-journal",
  });

  return (
    <div className="ag-area" key="agents-ready">
      <RouterTabs tabs={tabs} label={t("agents.nav.aria")} data-testid="agents-subnav" />
      <div className="ag-body">
        <Outlet />
      </div>
    </div>
  );
}
